/// <reference path="../../types.d.ts" />
import {
  STORAGE_KEY_LANG,
  STORAGE_KEY_THEME,
  STORAGE_KEY_SESSION_TOKEN,
  STORAGE_KEY_EDITOR_NAME,
  STORAGE_KEY_SESSION_ROLE,
  STORAGE_KEY_TREE_ANCESTOR_DEPTH,
  STORAGE_KEY_TREE_DESCENDANT_DEPTH,
  STORAGE_KEY_TREE_SHOW_SIBLINGS,
  STORAGE_KEY_TREE_SHOW_SPOUSES,
} from "./constants";

const getStorage = (key: string, fallback: string = "") => {
  if (typeof localStorage !== "undefined") {
    try {
      return localStorage.getItem(key) || fallback;
    } catch (_) {}
  }
  return fallback;
};

const getStorageInt = (key: string, fallback: number): number => {
  const val = getStorage(key, "");
  if (!val) return fallback;
  const parsed = parseInt(val, 10);
  return isNaN(parsed) ? fallback : parsed;
};

const getStorageBool = (key: string, fallback: boolean): boolean => {
  const val = getStorage(key, "");
  if (val === "true") return true;
  if (val === "false") return false;
  return fallback;
};

export const state: AppState = {
  lang: getStorage(STORAGE_KEY_LANG, "tr"),
  theme: getStorage(STORAGE_KEY_THEME, "light"),
  sessionToken: getStorage(STORAGE_KEY_SESSION_TOKEN, ""),
  editorName: getStorage(STORAGE_KEY_EDITOR_NAME, "Aile Editörü"),
  role: getStorage(STORAGE_KEY_SESSION_ROLE, "viewer"),
  viewerKey: "",
  editorKey: "",
  encryptedBundle: null,
  data: null,
  personList: [],
  auditLog: [],
  lastAuditId: 0,
  isSyncing: false,
  activeView: "tree",
  focusedId: "I227",
  focusHistory: [],
  ancestorDepth: getStorageInt(STORAGE_KEY_TREE_ANCESTOR_DEPTH, 12),
  descendantDepth: getStorageInt(STORAGE_KEY_TREE_DESCENDANT_DEPTH, 3),
  showSiblings: getStorageBool(STORAGE_KEY_TREE_SHOW_SIBLINGS, true),
  showSpouses: getStorageBool(STORAGE_KEY_TREE_SHOW_SPOUSES, true),
  selectedDrawerId: null,
  kinshipA: "I0",
  kinshipB: "I227",
  panX: 0,
  panY: 0,
  scale: 0.72,
  isDragging: false,
  dragStartX: 0,
  dragStartY: 0,
  focusedNodeCoords: { x: 0, y: 0 },
  treeBounds: { width: 1000, height: 800 },
  layoutNodes: [],
  fanPanX: 0,
  fanPanY: 0,
  fanScale: 1,
  mapYear: 2026,
  mapBranch: "all",
  mapEvent: "all",
  mapPlaying: false,
  mapPlayTimer: null,
  mapStoryStep: 0,
  mapStoryActive: false,
  mapSelectedCity: null,
  mapPanX: 0,
  mapPanY: 0,
  mapScale: 1,
  mapIsDragging: false,
  mapDragStartX: 0,
  deferredInstallPrompt: null,
  timelineMode: "lifespans",
  timelineBranch: "all",
  timelineGen: "all",
  timelineType: "all",
  archiveData: null,
  archiveFilters: { cat: "", format: "all", type: "all", year: "all", contributor: "", query: "", showAll: false },
  archiveViewMode: "grid",
  activeArchiveDocId: null,
  lightboxState: { zoom: 1, rotate: 0, panX: 0, panY: 0, isDragging: false, startX: 0, startY: 0 },
} satisfies AppState;
